import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import call_jurisdictions_Service from "./call_jurisdictions_service";
import { toast } from "react-toastify";
const initialState = {
  call_jurisdictions: {},
  isError: false,
  isSuccess: false,
  isLodaing: false,
  massage: "",
};

export const store_call_jurisdictions = createAsyncThunk(
  "call_jurisdictions/post",
  async (data, thunkAPI) => {
    try {
      return await call_jurisdictions_Service._store_call_jurisdictions(data);
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      error?.response?.data?.errors?.map((err) =>
        toast.error(err.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      );
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const get_call_jurisdiction_data = createAsyncThunk(
  "call_jurisdictions/get",
  async (ticket_id, thunkAPI) => {
    try {
      return await call_jurisdictions_Service.get_call_jurisdictions_data(
        ticket_id
      );
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const update_call_jurisdictions = createAsyncThunk(
  "call_jurisdictions/post",
  async (data, thunkAPI) => {
    try {
      return await call_jurisdictions_Service.edit_call_jurisdictions(data);
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      error?.response?.data?.errors?.map((err) =>
        toast.error(err.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      );
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const call_jurisdictionsSlice = createSlice({
  name: "call_jurisdictions",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLodaing = false;
      state.massage = "";
    },
  },
  extraReducers: {
    //store_call_jurisdictions
    [store_call_jurisdictions.pending]: (state) => {
      state.isLodaing = true;
    },
    [store_call_jurisdictions.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.call_jurisdictions = payload;
    },
    [store_call_jurisdictions.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },

    //get_call_jurisdiction_data
    [get_call_jurisdiction_data.pending]: (state) => {
      state.isLodaing = true;
    },
    [get_call_jurisdiction_data.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.call_jurisdictions = payload;
    },
    [get_call_jurisdiction_data.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.call_jurisdictions = null;
      state.massage = action.payload;
    },

    //edit_call_jurisdictions
    [update_call_jurisdictions.pending]: (state) => {
      state.isLodaing = true;
    },
    [update_call_jurisdictions.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.call_jurisdictions = payload;
    },
    [update_call_jurisdictions.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },
  },
});

export const { reset } = call_jurisdictionsSlice.actions;
export default call_jurisdictionsSlice.reducer;
